import { ENV_JS } from '../utils/env_module'

callpy_global.CCallpy = function() {
    this.module_name = "Callpy ";
    this.module_log_rang = 100;
    window.callpy_inited = false;

    var _this = this;

    //TODO: потом убрать
    if (!window?.callpy_from_ls) window.callpy_from_ls = false;
    if (!window?.callpy_css) window.callpy_css = false;

    if (callpy_from_ls == true){
        this.client_data = callpy_storage.m_callpy.client_data;

        this.users_list = callpy_storage.m_callpy.users_list;
        this.managers_list = callpy_storage.m_callpy.managers_list;

        //callpy_global.callpy = callpy_storage.callpy_global.callpy;
        callpy_global.php_server = callpy_storage.callpy_global.php_server;
        callpy_global.callpy_domain = callpy_storage.callpy_global.callpy_domain;
        callpy_global.modules = {};
    }else{
        this.client_data = {};

        this.client_data.browser = null;
        this.client_data.site = null;
        this.client_data.type = null;
        this.client_data.connected = false;
        this.client_data.registered = false;
        this.client_data.peer_key = 0;
        this.client_data.peer_type = 0;
        this.client_data.dialogs = {};
        this.client_data.dialog_id = 0;
        this.client_data.dialogs_participants = {};

        this.users_list = {};
        this.managers_list = {};
    }

    this.init = function ()
    {
        //FIXED:
        //На некоторых движках код (видимо, автоматически) вставляется два раза. При инициализации скриптов Callpy это можно проверить по уже существующим объектам
        //в объекте m_callpy. Запрещаем повторную инициалзиацию на странице
        if (window.location.href.indexOf("samsung.com/ua")!=-1) return;
        if (window.location.href.indexOf("samsung.com/kz_ru")!=-1) return;
        if (_this.m_loader) return;
        if (window.callpy_inited) return;
        window.callpy_inited = true;
        _this.m_cookie = callpy_global.registerModule("callpy_global.CCookie");
        _this.client_data.browser = _this.get_browser();
        _this.client_data.type = _this.get_client_type();
        if (_this.client_data.type!=2) _this.client_data.site = _this.get_site();
        else _this.client_data.site = null; //у консультанта переменная указывает на сайт выбранного клиента. В момент инициализации - null, никто не выбран
        window.m_callpy_site = _this.client_data.site;
       
        if (!callpy_from_ls && _this.client_data.type == 1){
            localStorage.removeItem("callpy_cid"); //удаляем данные о timestamp последнего полученного из Realplexor сообщения. Если восстанавливаемся не из LS, то это первый вход, подписываемся на канал с момента генерации страницы
            localStorage.setItem("callpy_enterTime", new Date().getTime()); //время входа на сайт запомним в LS
            localStorage.removeItem("callpy_am"); //удаляем данные о том, что было показано автоприветствие (оно может быть показано снова, т.к. началась новая сессия)
            localStorage.removeItem("callpy_hm"); //время запуска таймера удерживающих сообщений (1 на сессию)
            if (!localStorage.getItem("callpy_greets_timer") || ((new Date().getTime() - localStorage.getItem("callpy_greets_timer")) > 1000 * 60 * 180))
            localStorage.removeItem("callpy_greets"); //здесь хранятся показанные за время сессии автоприглашения (idшники)

            localStorage.removeItem("callpy_holds"); //аналогично, удерживающие

            localStorage.removeItem("callpy_call_flag");
            localStorage.removeItem("callpy_control_flag");
            localStorage.removeItem("callpy_state");
        }

        _this.m_loader = callpy_global.registerModule("callpy_global.CLoader");//Загрузка css, scripts, и второй запрос с типом клиента

        _this.m_logger = callpy_global.registerModule("callpy_global.CLogger");//Логи
        _this.m_message = callpy_global.registerModule("callpy_global.CMessage");//Шаблоны сообщений
        _this.m_bridge = callpy_global.registerModule("callpy_global.CBridge");//Связь с пхп
        _this.realplexor = callpy_global.registerModule("callpy_global.Dklab_Realplexor");
        //FIXED: модуль API подключаем сразу же для возможности делать отложенные вызовы API функций сразу после инициализации Callpy
        _this.api = callpy_global.registerModule("callpy_global.CApi");
        window.callpy_api = _this.api;
        if (_this.m_logger &&
            _this.m_message &&
            _this.m_bridge &&
            _this.m_loader)
        {
            _this.m_bridge.init(); //Создает слушателей для окна родителя и iframe (для менеджера)
            _this.m_message.init_templates();
            if (_this.check_browser(_this.client_data.browser)) //В данный момент всегда возвращает true, в дальнейшем добавить проверку на тип браузера
            {
                _this.m_loader.load_callpy();
            }
        }
    };

    this.load_modules_complete = function ()
    {
        switch (_this.client_data.type)
        {
            case 1:
                //FIXED: теперь, когда известен домен сайта, m_callpy.client_data.site должен указывать на него, а не на хост страницы
                _this.client_data.site = m_callpy?.client_data?.site_info["domain"]??ENV_JS?.CALLPY_CLIENT_DATA?.SITE_URL;
                _this.m_storage = callpy_global.registerModule("callpy_global.CStorage");
                _this.m_user = callpy_global.registerModule("callpy_global.CUser");
                //_this.m_gui_chat = callpy_global.registerModule("callpy_global.CGUIChat");
                _this.m_chat = callpy_global.registerModule("callpy_global.CChat");
                _this.m_flash = callpy_global.registerModule("callpy_global.CFlash");
                _this.m_control = callpy_global.registerModule("callpy_global.CControl");
                _this.m_activity = callpy_global.registerModule("callpy_global.CActivity");
                _this.m_autos = callpy_global.registerModule("callpy_global.CAutos");
                //_this.api = callpy_global.registerModule("callpy_global.CApi");
                //window.callpy_api = _this.api;

                //FIXED: проверять callpy_global.callpy нет смысла; если она false, то лишь не нужно показывать offline-заглушку (менеджеров не будет, если она false)
                //if (_this.m_user && callpy_global.callpy)
                if (_this.m_user)
                {
                    //UPDATED: проверка на блокировку выполнения на определённых страницах
                    if (_this.m_autos.checkBlockConditions()){
                        _this.api = null;
                        return; //блокировка выполнения скриптов Callpy
                    }
                    console.log('_this', _this)
                    _this.m_storage.init();
                    _this.m_user?.init();
                    _this.m_chat?.init();
                    _this.m_activity.init();
                    _this.m_autos.init();
                    //UPDATED: событие окончания загрузки Callpy
                    if (window.CallpyLoadHandler && typeof window.CallpyLoadHandler == "function"){
                        window.CallpyLoadHandler();
                    }
                }
                break;
            case 2:
                _this.m_chat = callpy_global.registerModule("callpy_global.CChat");
                _this.m_flash = callpy_global.registerModule("callpy_global.CFlash");
                _this.m_manager = callpy_global.registerModule("callpy_global.CManager");

                if (_this.m_manager)
                {
                    _this.m_manager.init();
                    _this.m_chat.init();
                    if (CC_TESTING){
                        _this.m_ccenter = callpy_global.registerModule("callpy_global.CCcenter");
                        _this.m_ccenter.init();
                    }
                }
                break;
            case 3:
                _this.m_control = callpy_global.registerModule("callpy_global.CControl");

                _this.m_control.init();

                break;
            case 4:
                _this.m_control = callpy_global.registerModule("callpy_global.CControlCframe");

                //FIXED: подключим CSS (т.к. это клиентский фрейм, то CSSка обязательно должна быть уже сохранена в LS)
                var css = document.createElement("style");
                css.type = "text/css";
                css.innerHTML = localStorage.getItem("callpy_css");
                document.getElementsByTagName("head")[0].appendChild(css);

                _this.m_control.init();

                break;
        }
    };

    this.create_callpy_block = function()
    {

        if (m_callpy.client_data.type != 2) {
            //$jcallpy('<div>', {id:'callpy'}).appendTo('body')
            const elem = document.createElement('div')
            elem.id = 'callpy'
            document.body.appendChild(elem)
        }

        if (m_callpy.m_flash && m_callpy.m_manager)
        {  //TODO перенести html-код блока в отдельный template
            $jcallpy('<div>', {
                id:'callpy_flash_wrap',
                css: {
                    position: "fixed",
                    left: "-500px"
                },
                'data-status': 'chat',
                html: '<div id="callpy_flash_wr"></div>'
            }).appendTo('#callpy');
        }
    };

    this.manager_changed = function (data)
    {

        if (_this.m_user && _this.client_data.type == 1)
        {
            _this.m_user.manager_changed(data);
        }

        if (_this.m_manager && _this.client_data.type == 2)
        {
            if (_this.isClientInManagerHistoryList(data["site_id"], data["user"])) data.inHistoryList = true;
            _this.m_manager.manager_changed(data);
        }
    };

    this.isClientInManagerHistoryList = function (site_id, id)
    {
        for (var i = 0; i < m_callpy.initialize_data.hlist.length; i++) if (m_callpy.initialize_data.hlist[i] == site_id + "_" + id){
            return true;
        }
        return false;
    };

    this.bridge_ready = function ()
    {
        switch (_this.client_data.type)
        {
            case 1:
                m_callpy.m_user.bridge_ready();
                break;
            case 2:
                m_callpy.m_manager.bridge_ready(); //У менеджера эта функция вызывает connect_to_fms (которая коннектится к Realplexor)
                break;
        }
    };

    this.add_manager = function (data)
    {
        var tmp = true; //был ли уже в списке
        if (!m_callpy.managers_list[data["key"]]) tmp = false;

        if (m_callpy.m_user)
        {
            m_callpy.managers_list[data["key"]] = data;
            m_callpy.m_user.add_manager(data, tmp);
        }
        if (m_callpy.m_manager)
        {
            if (!m_callpy.managers_list[data["site_id"]]){
                m_callpy.managers_list[data["site_id"]] = {};
            }
            m_callpy.managers_list[data["site_id"]][data["key"]] = data;
            m_callpy.m_manager.add_manager(data);
        }
    };

    this.add_user = function (data)
    {
        if (m_callpy.client_data.type != 1 || data["key"] != m_callpy.client_data.key)
        {
            if (!m_callpy.users_list[data["site_id"]]) m_callpy.users_list[data["site_id"]] = {};
            if (m_callpy.initialize_data.hlist[data["site_id"]+"_"+data["key"]]) data.inHistoryList = true;
            m_callpy.users_list[data["site_id"]][data["key"]] = data;

        }

        if (m_callpy.m_manager)
        {
            m_callpy.m_manager.add_user(data)
        }
    };

    this.remove_manager = function (data)
    {
        if (m_callpy.m_user)
        {
            m_callpy.managers_list[data["key"]] = null;
            m_callpy.m_user.remove_manager(data);
        }else{
            //TODO GUI: обновить список менеджеров у менеджера
            var name = m_callpy.managers_list[data["site_id"]][data["key"]].name+" "+m_callpy.managers_list[data["site_id"]][data["key"]].subname;
            m_callpy.managers_list[data["site_id"]][data["key"]] = null;
            $jcallpy.callpy_notify('drawNotification', {siteId: data["site_id"], clientId: data["key"], siteUrl: m_callpy.client_data.site_info[data["site_id"]].domain, type: "offManager", title: m_callpy.client_data.site_info[data["site_id"]].domain, text: _("Консультант")+" "+name+" "+_("покинул сайт")});
            gui.manager('remove', data["key"], data["site_id"]);
        }
    };

    this.remove_user = function (data)
    {
        if (!m_callpy.users_list[data["site_id"]]) m_callpy.users_list[data["site_id"]] = {};
        //посетитель уходит, по нему есть история - добавляем в список ушедших
        if (m_callpy.m_chat.history && m_callpy.m_chat.history[data["site_id"]] && m_callpy.m_chat.history[data["site_id"]][data["key"]]){
            if (!m_callpy.m_chat.historyArchive[data["site_id"]]) m_callpy.m_chat.historyArchive[data["site_id"]] = {};

            //m_callpy.m_chat.historyArchive[data["site_id"]][data["key"]] = {};
            //m_callpy.m_chat.historyArchive[data["site_id"]][data["key"]]['history'] = JSON.parse(JSON.stringify(m_callpy.m_chat.history[data["site_id"]][data["key"]]));
            //m_callpy.m_chat.historyArchive[data["site_id"]][data["key"]]['info'] = JSON.parse(JSON.stringify(m_callpy.users_list[data["site_id"]][data["key"]]));
            /*
            m_callpy.m_chat.historyArchive[data["site_id"]][data["key"]]['history'] = Array.prototype.map.call(m_callpy.m_chat.history[data["site_id"]][data["key"]], function (x) {
                return {
                    managerId: x.managerId,
                    managerName: x.managerName,
                    message: x.message,
                    receiver: x.receiver,
                    recieved: x.recieved,
                    sender: x.sender,
                    time: x.time
                };
            });
            m_callpy.m_chat.historyArchive[data["site_id"]][data["key"]]['info'] = Array.prototype.map.call(m_callpy.users_list[data["site_id"]][data["key"]], function (x) {
                return {
                    browser: x.browser,
                    channel: x.channel,
                    chatStatus: x.chatStatus,
                    chatWindowStatus: x.chatWindowStatus,
                    city: x.city,
                    sender: x.sender,
                    time: x.time
                };
            });
            */
            /*
            for (var i=0; i<m_callpy.m_chat.history[data["site_id"]][data["key"]].length; i++){
                m_callpy.m_chat.historyArchive[data["site_id"]][data["key"]].push({
                    managerId: m_callpy.m_chat.history[data["site_id"]][data["key"]][i].managerId,
                    managerName: m_callpy.m_chat.history[data["site_id"]][data["key"]][i].managerName,
                    message: m_callpy.m_chat.history[data["site_id"]][data["key"]][i].message,
                    receiver: m_callpy.m_chat.history[data["site_id"]][data["key"]][i].receiver,
                    recieved: m_callpy.m_chat.history[data["site_id"]][data["key"]][i].recieved,
                    sender: m_callpy.m_chat.history[data["site_id"]][data["key"]][i].sender,
                    time: m_callpy.m_chat.history[data["site_id"]][data["key"]][i].time
                });
            }
            m_callpy.m_chat.historyArchive[data["site_id"]][data["key"]] = m_callpy.m_chat.history[data["site_id"]][data["key"]];
            */
            //m_callpy.m_chat.history[data["site_id"]][data["key"]] = null;
        }
        //m_callpy.users_list[data["site_id"]][data["key"]] = null;
        m_callpy.users_list[data["site_id"]][data["key"]].online = false;
        m_callpy.users_list[data["site_id"]][data["key"]].activeStatus = m_callpy.users_list[data["site_id"]][data["key"]].getActiveStatus();

        if (m_callpy.m_manager)
        {
            m_callpy.m_manager.remove_user(data);
        }
    };

    this.go_url = function (data)
    {
        if (m_callpy.m_user)
        {
            m_callpy.m_user.go_url(data["url"]);
        }

        if (m_callpy.m_manager)
        {
            //сообщение go_url приходит только от активной вкладки. Т.е. клиент не может быть "не активным" (на самом деле может, если, к примеру, идет УУ и консультант сам переходит по странице, а у клиента она не активна)
            if (!data["noFocus"])m_callpy.m_manager.update_status({action: "update_status", status: "1"+m_callpy.users_list[data["site_id"]][data["key"]].chatWindowStatus + m_callpy.users_list[data["site_id"]][data["key"]].chatStatus, peer_key: m_callpy.client_data.key, domain: data["domain"], site_id: data["site_id"], key: data["key"], type: "1", where: "to_fms", id: data["key"]});

            //если только выбран этот клиент (теоретически менеджер может успеть перевключиться на другого до того, как придет сообщение)
            if (m_callpy.m_manager.isClientSelected(data["site_id"], data["key"])){
                if (data["width"]) m_callpy.m_manager.set_display_size({width: data["width"]});
                //TODO: добавить передачу массива inputs, если существует
                //m_callpy.m_manager.go_url(data["url"], data["scroll"], data["refresh"], data["elements"], data["focusTime"], data["noFocus"]);
                m_callpy.m_manager.go_url(data);
            }

        }
    };

    this.parseUrl = function ( url ) {
        var a = document.createElement('a');
        a.href = url;
        return a;
    }

    this.register_client = function (data)
    {
        if (m_callpy.client_data.key == data["key"] &&
            m_callpy.client_data.type == data["type"] &&
            !m_callpy.client_data.registered)
        {
            if (m_callpy.m_user && m_callpy.client_data.type == 1)
            {
                m_callpy.m_user.register_complete(data);
            }
            if (m_callpy.m_manager && m_callpy.client_data.type == 2)
            {
                m_callpy.client_data.phrases = [];
                for (var i in data["phrases"])
                {
                    m_callpy.client_data.phrases.push(data["phrases"][i]);
                }
                if (m_callpy.initialize_data["online"]==0){ //менеджер был дисконнекчен от Realplexor
                    localStorage.removeItem("callpy_mcid"); //консультант: время последнего полученного сообщения из собственного канала и каналов сайтов
                }

                m_callpy.m_manager.register_complete(data);
            }
            m_callpy.client_data.registered = true;
        }
        else
        {
            if (data["type"] == 1)
            {
                m_callpy.add_user(data);
            } //FIXED: после рефакторинга у пользователей нет различия админ/консультант (type == 2|3), data["type"] не может быть "3". Однако, на всякий случай оставил пока
            if (data["type"] == 2 || data["type"] == 3)
            {
                m_callpy.add_manager(data);
            }
            if (data["type"] == 0){
                m_callpy.m_manager.add_manager(data);
            }
        }
    };

    this.unregister_client = function (data)
    {
        if (m_callpy.client_data.key == data["key"] &&
            m_callpy.client_data.type == data["type"] &&
            m_callpy.client_data.registered)
        {
            if (m_callpy.m_user && m_callpy.client_data.type == 1)
            {
                m_callpy.m_user.unregister(data);
            }
            if (m_callpy.m_manager && m_callpy.client_data.type == 2)
            {
                //m_callpy.m_cookie.delete_cookie("PHPSESSID");
                //m_callpy.m_cookie.delete_cookie("callpy_mkey");

                //UPDATED: когда удаляют консультанта с сайта, у него выполняется код ниже. Панель нет необходимости перезагружать, самого себя удалить из списка консультантов сайта
                //можно
                //window.location.href = callpy_global.php_server.replace("https", "http");
                //m_callpy.m_manager.unregister(data);
                m_callpy.remove_manager(data);
            }
        }
        else
        {
            if (data["type"] == 1)
            {
                m_callpy.remove_user(data);
            }
            if (data["type"] == 2)
            {
                m_callpy.remove_manager(data);
            }
        }
    };

    this.set_peer = function ()
    {
        var data = {};

        if (m_callpy.client_data.type == 1 && m_callpy.managers_list[m_callpy.m_user.selected_manager])
        {
            (m_callpy.m_user.selected_manager == 0) ? m_callpy.client_data.peer_type = 0 : m_callpy.client_data.peer_type = 2;
            m_callpy.client_data.peer_key = m_callpy.m_user.selected_manager;

            data.type = 2;
            data.key = m_callpy.m_user.selected_manager;

            //TODO: FLAT
            //обновляем данные LS
            //заглушку для удаленного управления и при звонке пишем только при смене консультанта (а без консультанта и нельзя начать ни звонок, ни УУ) и только если данных в LS нет (код одинаковый)
            //if (localStorage.getItem("callpy_html_rc")==null) localStorage.setItem("callpy_html_rc", m_callpy.m_gui_chat.stop_remote_html());
            //if (localStorage.getItem("callpy_html_cl")==null) localStorage.setItem("callpy_html_cl", m_callpy.m_gui_chat.stop_call_html());
            //а запрос удаленного управления содержит иконку и имя консультанта, поэтому данные LS обновляем при каждой смене
            //localStorage.setItem("callpy_html_rr", m_callpy.m_gui_chat.request_remote_html());
            //флаг состояния callpy (если нет - обычное, 1 - запрос УУ, 2 - УУ, 3 - звонок)
            localStorage.removeItem("callpy_call_flag");
            localStorage.removeItem("callpy_control_flag");

        }

        if (m_callpy.client_data.type == 2 && m_callpy.users_list[m_callpy.client_data.site_id][m_callpy.m_manager.selected_user])
        {
            (m_callpy.m_manager.selected_user == 0) ? m_callpy.client_data.peer_type = 0 : m_callpy.client_data.peer_type = 1;
            m_callpy.client_data.peer_key = m_callpy.m_manager.selected_user;

            data.type = 1;
            data.key = m_callpy.m_manager.selected_user;
        }

        if (data.key && data.type)
        {

        }
        else
        {
            m_callpy.client_data.peer_type = 0;
            m_callpy.client_data.peer_key = 0;
        }
    };

    this.check_browser = function() //TODO: дописать проверку поддерживаемых версий браузеров
    {
        return true;
    };

    this.get_site = function()
    {
        //TODO: для сайтов тест-драйва теперь будет один и тот же домен: testdrive.callpy.com
        //TODO: необходимо различать эти сайты, и поменять здесь способ определения
        //TODO: в тест-драйве используется файл cookie, содержащий реальный адрес сайта
        const siteUrl = m_callpy.convertPunycode((location.host.indexOf('localhost:')!==-1)?(ENV_JS?.CALLPY_CLIENT_DATA?.SERVER??null):location.host.replace(/www./i, "")); //location.host.replace(/www./i, "")
        return siteUrl
    };

    //тип клиента. 1 - основное окно клиента; 2 - основное окно менеджера (в них - комет-запросы и флешки, основной код)
    //3 - iframe менеджера (в нем он видит страницу клиента); 4 - iframe клиента (используется только для звонков, чтобы не сбрасывать вызов)
    this.get_client_type = function()
    {
        if (window.top == window)
        {
            if (location.href == "https://panel.rt.ru/manager/" || location.href == "https://panel.rt.ru/manager" || (location.host.replace(/www./i, "")+"/" == callpy_global.php_server.replace("https", "http").replace("http://", "") && (location.pathname == "/manager" || location.pathname == "/manager/"))){
                return 2;
            }else if (location.host.replace(/www./i, "")+"/" == callpy_global.php_server.replace("https", "http").replace("http://", "") && (location.pathname == "/sites/design/" || location.pathname == "/sites/design")){
                return 5;
            }else{
                return 1;
            }
            /*
            if (location.href.replace(/www./i, "") == callpy_global.php_server.replace("https", "http") + "manager/" || location.href.replace(/www./i, "") == callpy_global.php_server.replace("https", "http") + "manager")
            {
                return 2;
            }
            else
            {
                return 1;
            }
            */
        }
        else
        {

            try{
                if (parent.window.location.href.replace(/www./i, "") == callpy_global.php_server.replace("https", "http") + "manager/" || parent.window.location.href.replace(/www./i, "") == callpy_global.php_server.replace("https", "http") + "manager") return 3;
                else return 4;
            }catch (e){
                //alert(e);
                return 3;
            }

        }
    };

    this.get_browser = function(chrAfterPoint)
    {
        var
            UA=window.navigator.userAgent,
            OperaB = /Opera[ \/]+\w+\.\w+/i,
            OperaV = /Version[ \/]+\w+\.\w+/i,
            FirefoxB = /Firefox\/\w+\.\w+/i,
            ChromeB = /Chrome\/\w+\.\w+/i,
            SafariB = /Version\/\w+\.\w+/i,
            IEB = /MSIE *\d+\.\w+/i,
            SafariV = /Safari\/\w+\.\w+/i,

            browser = new Array(),
            browserSplit = /[ \/\.]/i,
            OperaV = UA.match(OperaV),
            Firefox = UA.match(FirefoxB),
            Chrome = UA.match(ChromeB),
            Safari = UA.match(SafariB),
            SafariV = UA.match(SafariV),
            IE = UA.match(IEB),
            Opera = UA.match(OperaB);

        if ((!Opera=="")&(!OperaV==""))
        {
            browser[0]=OperaV[0].replace(/Version/, "Opera");
        }
        else
        {
            if (!Opera=="")
            {
                browser[0]=Opera[0];
            }
            else
            {
                if (!IE=="")
                {
                    browser[0] = IE[0];
                }
                else
                {

                    if (!Firefox=="")
                    {
                        browser[0]=Firefox[0];
                    }
                    else
                    {
                        if (!Chrome=="")
                        {
                            browser[0] = Chrome[0];
                        }
                        else
                        {
                            if ((!Safari=="")&&(!SafariV==""))
                            {
                                browser[0] = Safari[0].replace("Version", "Safari");
                            }
                        }
                    }
                }
            }
        }

        var outputData;

        if (browser[0] != null)
        {
            outputData = browser[0].split(browserSplit);
        }

        if ((chrAfterPoint==null)&&(outputData != null))
        {
            chrAfterPoint=outputData[2].length;
            outputData[2] = outputData[2].substring(0, chrAfterPoint);
            return(outputData);
        }
        else
        {
            return(false);
        }
    };

    this.isMobile = function()
    {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    }

    this.urlHighlight = function (str)
    {
        //автоподстановка ссылок
        var patternUrl = /(?:https?:\/\/|([^@\wа-яА-ЯёЁ.\-0-9]{1})|^)(?:https?:\/\/)?((?:www|[\wа-яА-ЯёЁ\-0-9]+\.)[^@<\s]+[^@<.,:;?!”»’“+\-\)\s])/gi;
        var matches = str.match(patternUrl);

        //var pat = /(?:([^@\w.\-0-9]{1})|^)([^а-яА-ЯёЁ]+\.[a-z]+(?:[^а-яА-ЯёЁ]+)?)$/i;
        var pat = /(?:https?:\/\/|([^@\wа-яА-ЯёЁ.\-0-9]{1})|^)(?:https?:\/\/)?((?:www\.|[\w\-0-9]+\.)[^@<\s\/]+[a-zA-Z]+(?:\/[^@<\s]+[^@<.,:;?!”»’“+\-\)\s])?)/i;
        var patRus = /(?:([^@\wа-яА-ЯёЁ.\-0-9]{1})|^)((?:.)*\.(?:рф|рус|москва|онлайн|дети|сайт)(?:(?:.)*)?)$/i;
        var patRep;
        var rep;
        if (matches){
            for (var i=0;i<matches.length; i++){
                if (str.length>(str.indexOf(matches[i]) + matches[i].length) && str[(str.indexOf(matches[i]) + matches[i].length)] == "@") continue;
                if (matches[i].indexOf("https")==0 || matches[i].indexOf("https")==1){
                    patRep = "$1<a href=\"https://$2\" target=\"_blank\">https://$2</a>";
                }else if(matches[i].indexOf("http")==0 || matches[i].indexOf("http")==1){
                    patRep = "$1<a href=\"http://$2\" target=\"_blank\">http://$2</a>";
                }else{
                    patRep = "$1<a href=\"//$2\" target=\"_blank\">$2</a>";
                }
                rep = matches[i].replace(pat, patRep);
                if (rep == matches[i]){
                    rep = matches[i].replace(patRus, patRep);
                }
                str = str.replace(matches[i], rep);
            }
        }
        //UPDATED: обрежем видимую часть ссылок
        patternUrl = /\>(([^\<]{30})([^\<]+))\<\/a\>/gi;
        rep = ">$2...</a>";
        str = str.replace(patternUrl, rep);

        var patternMail = /([\w\-0-9а-яА-ЯёЁ\_\+\=.]+@[\wа-яА-ЯёЁ\-0-9]+\.[\w\-0-9а-яА-ЯёЁ]+)/gi;
        var replaceMail = "<a href=\"mailto:$1\">$1</a>";
        return str.replace(patternMail, replaceMail);
    };

    this.urlBackReg = function (str)
    {
        var pattern = /\<a href\=\"(?:\/\/|mailto\:)?([^\"]+)\"[^\>]{0,}\>[^\<]{0,}\<\/a\>/gi;
        str = str.replace(pattern, "$1");
        //str = str.replace(/mailto\:/gi, "$1");
        //if (str.indexOf("mailto:") === 0) str = str.substr(7);
        //console.log("До удаления //:", str);
        //if (str.indexOf("//") === 0) str = str.substr(2);
        //console.log("После удаления //:", str);
        return str;
    };

    this.parseTimestamp = function (timestamp)
    {
        var currentDate = new Date();
        var timeDate = new Date(timestamp);
        //в случае, если текущая дата отличается от переданной, кроме времени, возвращаем дату:
        var months = [_("янв"), _("фев"), _("мар"), _("апр"), _("мая"), _("июн"), _("июл"), _("авг"), _("сен"), _("окт"), _("ноя"), _("дек")];
        if (currentDate.getDate()!=timeDate.getDate() || currentDate.getMonth() != timeDate.getMonth() || currentDate.getYear() != timeDate.getYear()){
            return timeDate.getDate()+" "+months[timeDate.getMonth()]+" "+timeDate.getHours()+":"+(timeDate.getMinutes()<10?"0"+timeDate.getMinutes():timeDate.getMinutes());
        }else{
            return ""+timeDate.getHours()+":"+(timeDate.getMinutes()<10?"0"+timeDate.getMinutes():timeDate.getMinutes());
        }
    };

    this.escapeHtml = function (text) {
        if (typeof text != "string") return text;
        var map = {
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;',
            "'": '&#039;'
        };

        return text.replace(/[&<>"']/g, function(m) { return map[m]; });
    }

    this.preg_quote = function (str) {
        return str.replace(/([\\\.\+\*\?\[\^\]\$\(\)\{\}\=\!\<\>\|\:])/g, "\\$1");
    };


    //0 - не видима вкладка, 1 - видима
    this.checkVisibility = function ()
    {
        return (document.mozHidden || document.msHidden || document.webkitHidden || document.hidden?0:1);
    }

    this.isMsie = function ()
    {
        return /(msie|trident)/i.test(navigator.userAgent) ? navigator.userAgent.match(/(msie |rv:)(\d+(.\d+)?)/i)[2] : false;
    }

    this.convertPunycode = function (str)
    {
        if (str.substr(0,4)=="xn--") return callpy_global.punycode.ToUnicode(str);
        else return str;
    }

}

if(callpy_global.registerModule) {
  var m_callpy = callpy_global.registerModule("callpy_global.CCallpy");
  var io = m_callpy; //FIXED: обратная совместимость - ранее в коде вставки был вызов io.init (теперь m_callpy заменяется на iowisp)
  window.m_callpy = m_callpy
  window.io = io
}
